export default "__VITE_ASSET__Bm7acGq2__"